<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/33JiZ3/tc-custom/9781035810031.jpg?1728169086066" alt="This image is the cover for the book 8 Seconds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">8 Seconds
      </h1>
      <p class="bookDescription body article font2">
        <p>8 Seconds defies easy categorization – it’s a compelling blend of mystery, fantasy, historical exploration, and philosophical inquiry. At its core is the character Harry Avramov, a modern-day Lucifer who emerged from a fractured childhood and damaged dignity. Driven by revenge, Harry becomes a spellbinding anti-hero who bends the rules of morality, flitting between this world and the otherworld while questioning the very nature of choice and destiny. Unfettered by genre conventions, the novel avoids expected resolutions, opting instead for a trio of unexpected, yet inevitable, endings. Steering clear of cliché, the story delves into the complex fabric of family and the consequences of its collapse. It draws inspiration from literary giants like Dante and Byron, as well as timeless Biblical themes, shaping the narrative into a contemporary parable rich with age-old wisdom. As Harry navigates the trials of existence and ambition, he ultimately finds himself journeying through time, from a cycle initiated 50,000 years ago to the present. It takes him a mere 8 seconds to confront the ultimate Truth – the essence of what truly matters in life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Blagomira Halacheva
      </h2>
      
      <p class="authorDescription body article">Blagomira Halacheva – Boggie – was born in Bulgaria. She graduated from medical college in Plovdiv and now she practices in Austria. Her son Rosen lives with his family in Wales, UK. The novel 8 Seconds was ranked second in the competition for a Bulgarian novel of the Bukvite Foundation. A film script was written based on the novel. The Silent World Publishing House published the first book titled Children of Sin, the second book Traps for Love and Power, and the third book of the trilogy, Redemption, of the Maria-Magdalene Trilogy. In 2014 at the Screen-Craft Family-Friendly Script Contest, the script Double Dimension by Blagomira Halacheva qualified of the Quarter-Finalists.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11976103